import { render, staticRenderFns } from "./preview_2.vue?vue&type=template&id=00bf79da&scoped=true"
import script from "./preview_2.vue?vue&type=script&lang=js"
export * from "./preview_2.vue?vue&type=script&lang=js"
import style0 from "./preview_2.vue?vue&type=style&index=0&id=00bf79da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf79da",
  null
  
)

export default component.exports